export default __webpack_public_path__ + "static/media/sp-sbo-boy.a5b4ea98.webp";